import { useCallback, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import MediaService from '../../services/MediaService';
import UnitNavigation from '../../components/Navigation/UnitNavigation';
import Surprise from '../../components/World/Surprise/Surprise';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';

const Module1Nav = () => {
  const { module1 } = useSelector((state) => state.module1, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  /*****************
   *  BG Image Logic
   * ***************/

  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseConfig, setSurpriseConfig] = useState(null);
  const bgImage = useRef();

  const checkScreenSize = () => {
    const desktopImage =
      '/Module1Images/Module1NavImages/JourneyMap_Background_Landscape.jpg';
    const mobileImage = '/Module1Images/Module1NavImages/M1_Path_Mobile.png';

    bgImage.current =
      window.screen && window.screen.width < 1025 ? mobileImage : desktopImage;
  };

  const resizeListener = useCallback(() => {
    window.addEventListener(
      'resize',
      (event) => checkScreenSize(),
      true
    );
  }, []);
  
  resizeListener();
  checkScreenSize();

  const backgroundPath =
    bgImage.current && MediaService.getImage(bgImage.current, login);
  const worldBG = MediaService.getImage(
    '/Module1Images/U1M1_Background_Landscape.png',
    login
  );

  /*****************
   *  Day Logic
   * ***************/

  const getDayConfig = useCallback((dayNumber) => {
    let filledImageUrl = `/Module1Images/Module1NavImages/Color_Day${dayNumber}.svg`;
    let outlinedImageUrl = `/Module1Images/Module1NavImages/Outline_Day${dayNumber}.svg`;

    // The trophy image is a png instead of a svg, that&apos;s why we do this
    if (dayNumber === 9) {
      outlinedImageUrl = outlinedImageUrl.replace('svg', 'png');
      filledImageUrl = filledImageUrl.replace('svg', 'png');
    }

    return {
      dayNumber,
      destiny: '/eye-contact',
      filledImageUrl,
      outlinedImageUrl,
    };
  }, []);

  const daysArray = [...Array(9).keys()];
  const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1));

  const SURPRISE_VIDEO = {
    video: 'd6c6b74e964a62fe8a9940bd860c/480.m3u8',
    song: 'appfiles/eye_contact/eye_contact_student_instrumental.m4a',
    slides: [
      `influencers/${login.influencerid}/greet_affirmation.mp4`,
      `userfiles/${module1.StudentID}/eye_contact_celebration_surprise_5.mp4`,
      `userfiles/${module1.StudentID}/eye_contact_smile.jpg`,
      `influencers/${login.influencerid}/eye_contact_video_message.mp4`,
      `userfiles/${module1.StudentID}/eye_contact_celebration_surprise_8.mp4`,
      `userfiles/${module1.StudentID}/eye_contact_silly_photo_1.jpg`,
      `userfiles/${module1.StudentID}/eye_contact_celebration_surprise_9.mp4`,
    ],
  };

  const handleSurpriseClick = async () => {
    let { slides, song, video } = SURPRISE_VIDEO;

    slides = await Promise.all(
      slides.map(async (url) => await GetUserVideo(url))
    );
    song = await getVideo(song, login);

    setSurpriseConfig({ video, slides, song });
    setDisplaySurprise(true);
  };

  /*****************************
   *  Component configuration
   * ***************************/

  return (
    <>
      {displaySurprise && (
        <Surprise
          background={worldBG}
          setDisplaySurprise={setDisplaySurprise}
          video={surpriseConfig.video}
          song={surpriseConfig.song}
          slides={surpriseConfig.slides}
          onSurpriseEnded={() => setDisplaySurprise(false)}
        />
      )}

      {backgroundPath && (
        <UnitNavigation
          moduleName='MODULE1'
          module={module1}
          days={DAYS_CONFIG}
          totalDays={9}
          unitDestiny='/unit1'
          nextDestiny='/unit1'
          backgroundPath={backgroundPath}
          onSurpriseClick={handleSurpriseClick}
          unit={1}
          animal={MediaService.getImage('/Images/Button_CrabHead.png', login)}
        />
      )}
    </>
  );
};
export default Module1Nav;
